import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { heightPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        marginTop: heightPercentageToDP(40),
    },
    time: {
        fontFamily: Fonts.main.bold,
        fontSize: 64,
        textAlign: 'center',
    },
});

export default styles;
